module.exports = __webpack_public_path__ + "img/43f3fabc0094af5e532340bf105b68ab.png";